import List from '@pelckmans/elementis/components/list';

type MaterialListHeaderProps<T> = {
  title: string;
  showSelection: boolean;
  selectedMaterial: T[];
  material: { id: T }[];
  addMaterial: (ids: T[]) => void;
  removeMaterial: (ids: T[]) => void;
};

export default function MaterialListHeader<T = string>({
  showSelection,
  title,
  selectedMaterial,
  material,
  addMaterial,
  removeMaterial,
}: MaterialListHeaderProps<T>) {
  if (showSelection) {
    const someSelected = material.some(m => selectedMaterial.includes(m.id));
    const allSelected = material.every(m => selectedMaterial.includes(m.id));

    const onClick = () => {
      if (allSelected) {
        removeMaterial(material.map(s => s.id));
      } else {
        addMaterial(material.map(s => s.id));
      }
    };

    return (
      <List.Header
        as="checkbox"
        title={title}
        titleTag="h3"
        prominent
        checked={someSelected}
        indeterminate={someSelected && !allSelected}
        onClick={onClick}
      />
    );
  }
  return <List.Header title={title} titleTag="h3" prominent />;
}
